<!-- timesheet时间表 -->
<template>
  <div class="timesheet">
    <div>
      <div>
        <div class="timesheet-title">
          <zlr-title title="Timesheet"></zlr-title>
        </div>
        <Form ref="formValidate"
              :model="formValidate"
              :rules="ruleValidate">
          <ul class="timesheet-search-con">
            <li>
              <FormItem label="Mentee">
                <Input v-model='formValidate.menteeName'
                       placeholder="Please enter"
                       clearable />
              </FormItem>
            </li>
            <li>
              <FormItem label="Module">
                <Select v-model="formValidate.module"
                        placeholder="Select"
                        clearable>
                  <Option v-for="item in packageModuleMap"
                          :key="item[0]"
                          :value="item[0]">{{item[1]}}</Option>
                </Select>
              </FormItem>
            </li>
            <li>
              <FormItem label="Date">
                <DatePicker type="datetimerange"
                            placeholder="Select date"
                            format="yyyy-MM-dd"
                            @on-change="changeTime"></DatePicker>
              </FormItem>
            </li>
            <li>
              <Button class="zlr-btn-default"
                      @click="handleSearch">Search</Button>
            </li>
          </ul>
        </Form>
        <template v-if="tableData.length">
          <Table :columns="columnsData"
                 :data="tableData"></Table>
          <div class="timesheet-page">
            <Page :total="page.totalItems"
                  :page-size="page.pageSize"
                  :current="page.currentPage"
                  @on-change="handlePageChange"></Page>
          </div>
        </template>
        <zlr-empty v-else></zlr-empty>
      </div>
    </div>
  </div>
</template>

<script>
// api
import timesheetService from '@/api/undergraduate/timesheet'
// less
import './timesheet.less'
// components
import ZlrTitle from '_c/title/title'
import ZlrEmpty from '_c/empty/empty'
// import { mapState } from 'vuex'
import { packageModuleMap } from './constants'
export default {
  name: 'undergraduate-timesheet',
  components: {
    ZlrTitle,
    ZlrEmpty
  },
  data () {
    return {
      // 套餐模块
      packageModuleMap,
      formValidate: {
        menteeName: '',
        module: '',
        createStartTime: '',
        createEndTime: ''
      },
      ruleValidate: {},
      columnsData: [
        {
          title: 'Mentee',
          key: 'menteeName',
          align: 'center',
          width: 180,
          fixed: 'left'
        },
        {
          title: 'Module',
          key: 'module',
          align: 'center',
          render (h, params) {
            let modules = params.row.module
            let title = ''
            if (modules) {
              title = new Map(packageModuleMap).get(modules)
            }
            return h('div', title)
          }
        },
        {
          title: 'Date',
          key: 'createTime',
          align: 'center'
        },
        {
          title: 'Time spent',
          key: 'timeSpent',
          align: 'center',
          width: 180,
          fixed: 'right'
        }
      ],
      tableData: [],
      page: {
        totalItems: 0,
        pageSize: 10,
        currentPage: 1
      }
    }
  },
  computed: {},
  mounted () {
    this.getPageList()
  },
  methods: {

    getPageList () {
      let data = {
        ...this.formValidate,
        ...this.page
      }
      data.currentPage = data.currentPage - 1
      timesheetService.timesheetList(data).then(res => {
        let page = res.data.page
        this.tableData = page.result
        this.page.totalItems = page.totalItems
      }).catch((res) => {
        this.$ugd_message(res.message, 'error')
        this.tableData = []
        this.page.totalItems = 0
      })
    },
    handleSearch () {
      this.getPageList()
    },
    handlePageChange (currentPage) {
      this.page.currentPage = currentPage
      this.getPageList()
    },
    changeTime (data) {
      this.formValidate.createStartTime = data[0]
      this.formValidate.createEndTime = data[1]
    }
  }
}
</script>
<style lang='less' scoped>
</style>
<style lang="less">
.timesheet {
  .ivu-picker-confirm-time {
    display: none;
  }
}
</style>
